import { Feedback } from "app-principal-componentes-visuales";
import { useHistory } from "react-router";
import React, { useContext } from "react";
import "./Cancelar.scss";
import { AsistenciaMedicaContext } from "../../contexts/AsistenciaMedicaContext";
import { IonCol, IonContent, IonFooter, IonGrid, IonPage, IonRow } from "@ionic/react";
import Footer from "../../components/Footer/Footer";
import { TextoComponente } from "../../interfaces/textoComponente.interface";

interface ILocationState {
	from: string;
}

const Cancelar = () => {
	const history = useHistory();
	const {isWeb, asistenciaMedica} = useContext(AsistenciaMedicaContext)
	const textoComponente: TextoComponente = asistenciaMedica.textoComponentes.find((textoComponente) => textoComponente.componente === "Cancelar");

	const cancelWithAnalytics = () => {
		history.replace("/asistenciamedica")
	}

	return (
		<IonPage>
		<div className="asistencia-error_page Cancelar">
			<IonGrid className={`${isWeb ? 'asistencia_content-container asistencia-web-mobile-padding' : ''}`}>
				<IonRow>
					<IonCol size='12'>
						<Feedback
							titulo={textoComponente.titulo}
							parrafo={textoComponente.subtitulo}
							handsPhoneExclamation
							labelButtonCancel={textoComponente.botones.find( btn => btn.nombre === 'cancelar-no' ).texto}
							onClickCancel={() => history.goBack()}
							labelButtonOk={textoComponente.botones.find( btn => btn.nombre === 'cancelar-si' ).texto}
							onClickOk={cancelWithAnalytics}
							id="feedback-cancelar"
						/>
					</IonCol>
				</IonRow>
			</IonGrid>
		</div>
		</IonPage>
	);
};

export default Cancelar;
